module.exports = __webpack_public_path__ + "img/stock4.acf320d3.png";